var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    viewBox: "0 0 128 80",
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128 75.7343674c0 2.3563028-1.911377 4.2656326-4.267687 4.2656326h-119.46768731c-2.35528981 0-4.26462569-1.9093298-4.26462569-4.2656326v-71.46669385c0-2.35732327 1.90933588-4.26767355 4.26462569-4.26767355h119.46768731c2.35631 0 4.267687 1.91035028 4.267687 4.26767355z",
    fill: "#e0e3fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 14h31v22h-31z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bbc0f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 54h22v6h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 54h22v6h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67 54h22v6h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 54h22v6h-22z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCard);
export default __webpack_public_path__ + "static/media/generic-card.30d9879b.svg";
export { ForwardRef as ReactComponent };